export default function SectionApp() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 max-w-3xl mx-auto">
          <div className="flex-shrink-0">
            <div className="relative w-44 h-44 md:w-52 md:h-52 rounded-2xl bg-background-200 overflow-hidden border border-background-300/50">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20dark%20movie%20streaming%20app%20interface%20with%20movie%20posters%20grid%20and%20golden%20accent%20UI%20elements%2C%20cinema%20app%20design%20on%20phone%20screen%2C%20dark%20mode%20mobile%20interface%2C%20minimalist%20and%20elegant%20layout%2C%20rich%20contrast%20with%20warm%20highlights%2C%20modern%20flat%20design%20style&width=520&height=520&seq=app-phone-2026&orientation=squarish"
                alt="夜猫影院手机端观影体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
              <span className="w-3 h-3 flex items-center justify-center"><i className="ri-smartphone-fill text-primary-400 text-xs"></i></span>
              <span className="text-xs text-primary-400 font-medium whitespace-nowrap">随时随地</span>
            </div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-3">移动观影</h2>
            <p className="text-sm text-foreground-300 leading-relaxed mb-5">
              夜猫影院完美适配手机与平板设备，无论你是在被窝里深夜刷片，还是通勤路上追一部热门电影推荐，都能享受流畅的高清电影播放体验。随时随地，打开即看，无需下载任何 App。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-950 font-medium text-sm hover:bg-primary-400 transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-play-circle-fill text-sm"></i></span>
                立即体验
              </a>
              <span className="text-xs text-foreground-500">无需安装，浏览器直接观看</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}